import { COUNTRIES } from "data/countries";

// merchantId layout: ver(2)|MCC(4)|country(3)|seq(6), composed as an UNPADDED
// number so leading version digits can collapse (version 1 → 14 digits, 0 → 13,
// ≥10 → 15). Right-anchor on the fixed-width tail — country is the 3 digits
// before the final 6-digit sequence — so it's correct for any version.
export function countryCodeFromMerchantId(merchantId: string): number | null {
  if (!merchantId || merchantId.length < 9) return null;
  const code = Number(merchantId.slice(-9, -6));
  return Number.isNaN(code) ? null : code;
}

// ISO alpha-2 ("US"/"GR") for the country encoded in the merchantId, or "" if the
// code isn't in the active COUNTRIES table.
export function countryAlpha2FromMerchantId(merchantId: string): string {
  const code = countryCodeFromMerchantId(merchantId);
  if (code === null) return "";
  return COUNTRIES.find((c) => c.code === code)?.alpha2 ?? "";
}
